// TODO fix
export const alphabeticallyByProp = prop => (objA, objB) => {
  const valueA = objA[prop]
  const valueB = objB[prop]
  return valueA - valueB
}
